import * as React from 'react';

import {cn} from '@/utils/ui';

const Table = React.forwardRef<
  HTMLTableElement,
  React.HTMLAttributes<HTMLTableElement>
>(({className, ...props}, ref) => (
  <table
    ref={ref}
    className={cn(
      'w-full border-separate border-spacing-y-1 text-sm',
      className
    )}
    {...props}
  />
));
Table.displayName = 'Table';

const TableHeader = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({className, ...props}, ref) => (
  <thead ref={ref} className={cn(className)} {...props} />
));
TableHeader.displayName = 'TableHeader';

const TableBody = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({className, ...props}, ref) => (
  <tbody ref={ref} className={cn(className)} {...props} />
));
TableBody.displayName = 'TableBody';

const TableRow = React.forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(({className, ...props}, ref) => (
  <tr ref={ref} className={cn(className)} {...props} />
));
TableRow.displayName = 'TableRow';

const TableHead = React.forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({className, ...props}, ref) => (
  <th
    ref={ref}
    className={cn(
      'relative bg-neutral-100 px-3 py-3 text-xs font-normal whitespace-nowrap text-neutral-dark',
      'first:rounded-l-medium last:rounded-r-medium',
      '[&:not(:last-child)]:after:absolute [&:not(:last-child)]:after:top-3 [&:not(:last-child)]:after:right-0 [&:not(:last-child)]:after:bottom-3 [&:not(:last-child)]:after:w-px [&:not(:last-child)]:after:bg-neutral-200',
      className
    )}
    {...props}
  />
));
TableHead.displayName = 'TableHead';

const TableCell = React.forwardRef<
  HTMLTableCellElement,
  React.TdHTMLAttributes<HTMLTableCellElement>
>(({className, ...props}, ref) => (
  <td
    ref={ref}
    className={cn(
      'relative bg-neutral-light px-3 py-2',
      'first:rounded-l-medium last:rounded-r-medium',
      '[&:not(:last-child)]:after:absolute [&:not(:last-child)]:after:top-3 [&:not(:last-child)]:after:right-0 [&:not(:last-child)]:after:bottom-3 [&:not(:last-child)]:after:w-px [&:not(:last-child)]:after:bg-neutral-200',
      className
    )}
    {...props}
  />
));
TableCell.displayName = 'TableCell';

export {Table, TableBody, TableCell, TableHead, TableHeader, TableRow};
